import { Options, XAxisPlotLinesOptions } from 'highcharts';
import moment, { Moment } from 'moment';
import { ProjectFinancialsBaseChartProps } from '../../types';
import {
  projectFinancialsBaseChartOptions,
  projectFinancialsBaseXAxisOptions,
} from './common';

interface ProjectFinancialsLineChartMeta
  extends ProjectFinancialsBaseChartProps {
  lastDateMarker?: Moment;
  todayLabel: string;
}

export const projectFinancialsLineChartOptions =
  ({
    lastDateMarker,
    todayLabel,
    currencyCode,
    revenueLabels,
    timeLabels,
    percentageLabels,
  }: ProjectFinancialsLineChartMeta) =>
  (): Options => ({
    ...projectFinancialsBaseChartOptions({
      chartOptions: {
        type: 'spline',
      },
      tooltipProps: {
        type: 'spline',
        showX: true,
        currencyCode,
        revenueLabels,
        timeLabels,
        percentageLabels,
      },
    }),
    plotOptions: {
      spline: {
        marker: {
          symbol: 'circle',
          enabled: false,
          radius: 3,
        },
      },
    },
    xAxis: projectFinancialsBaseXAxisOptions({
      tickInterval: 24 * 3600 * 1000,
      crosshair: {
        width: 8, // cant use variable as this needs number
        color: 'var(--blue-10)',
        zIndex: 1,
      },
      labels: {
        autoRotation: undefined,
        overflow: 'allow',
        formatter: (obj) => {
          const valueMoment = moment(obj.value);

          if (valueMoment.isSame(moment(), 'day')) {
            return todayLabel;
          }
          if (lastDateMarker && valueMoment.isSame(lastDateMarker, 'day')) {
            return valueMoment.format('DD MMM');
          }

          return '';
        },
      },
      plotLines: [
        {
          value: moment().startOf('day').utc().valueOf(),
          color: 'var(--red-60)',
          width: 2,
          zIndex: 3,
        },
        ...(lastDateMarker
          ? [
              {
                value: lastDateMarker.utc().valueOf(),
                color: 'var(--green-40)',
                width: 2,
                zIndex: 3,
                dashStyle: 'ShortDash',
              } as XAxisPlotLinesOptions,
            ]
          : []),
      ],
    }),
  });
